export const DefaultSearchUser = {
  page_no: 1,
  page_size: 12,
  group_id: "",
  name: "",
};

export const DefaultRoleDesc = "일반";
export const AdminRoleName = "roles.admin";
export const FinanceRoleName = "roles.finance";
export const ProductManagerRoleName = "roles.pm";
